import React from "react";

// local
import { DashboardPage as Component } from "./Component";

export * from "./Component";

export const DashboardPage = React.memo(Component);
